// stop judging me for this pls

const colours12 = [
    "primary",
    "#64247D",
    "#71217E",
    "#7F1D80",
    "#8D1981",
    "#9A1683",
    "#A81284",
    "#B50F86",
    "#C30B87",
    "#D10789",
    "#DE048A",
    "#EC008C"
]

const colours11 = [
    "primary",
    "#65247D",
    "#74207E",
    "#831C80",
    "#921882",
    "#A11484",
    "#B01085",
    "#BF0C87",
    "#CE0889",
    "#DD048A",
    "#EC008C"
]

const colours10 = [
    "primary",
    "#67247D",
    "#771F7F",
    "#881B81",
    "#991683",
    "#A91284",
    "#BA0D86",
    "#CB0988",
    "#DB048A",
    "#EC008C"
]

const colours9 = [
    "primary",
    "#69237D",
    "#7C1E7F",
    "#8E1981",
    "#A11484",
    "#B40F86",
    "#C70A88",
    "#D9058A",
    "#EC008C"
]

const colours8 = [
    "primary",
    "#6B227D",
    "#811D80",
    "#961782",
    "#AC1185",
    "#C10B87",
    "#D7068A",
    "#EC008C"
]

const colours7 = [
    "primary",
    "#6F217E",
    "#881B81",
    "#A11484",
    "#BA0D86",
    "#D30789",
    "#EC008C"  
]

const colours6 = [
    "primary",
    "#74207E",
    "#921882",
    "#B01085",
    "#CE0889",
    "#EC008C"
]

const colours5 = [
    "primary",
    "#7C1E7F",
    "#A11484",
    "#C70A88",
    "#EC008C",
]

const colours4 = [
    "primary",
    "#881B81",
    "#BA0D86",
    "#EC008C",
]

const colours3 = [
    "primary",
    "#A11484",
    "#EC008C"
 
]

const colours2 = [
    "primary",
    "secondary"
]

const colours1 = [
    "primary"
]

export const ColoursForTiles = [
    colours1,
    colours2,
    colours3,
    colours4,
    colours5,
    colours6,
    colours7,
    colours8,
    colours9,
    colours10,
    colours11,
    colours12
]